export default __webpack_public_path__ + "static/media/newIcon.540f1ec8.svg";